import * as React from 'react';
import { useMediaQuery } from '@kvika/hooks';
import Button, { ButtonBackgroundType } from '@kvika/button';
import { MediaQuery } from '@kvika/theme';
import { StyledPdfContainer, StyledPdf, StyledMobileContainer } from './styles/DocumentStyles';
var Document = function (_a) {
    var testId = _a.testId, openDocumentLabel = _a.openDocumentLabel, url = _a.url, onClick = _a.onClick, className = _a.className;
    var isMobile = useMediaQuery("(max-width: ".concat(MediaQuery.Tablet, ")"));
    if (isMobile) {
        return (React.createElement(StyledMobileContainer, { className: className, "data-testid": "container-".concat(testId) },
            React.createElement(Button, { width: "100%", "data-testid": "button-".concat(testId), onClick: onClick, backgroundType: ButtonBackgroundType.Outlined }, openDocumentLabel)));
    }
    return (React.createElement(StyledPdfContainer, { className: className, "data-testid": testId },
        React.createElement(StyledPdf, { data: url })));
};
export default Document;
//# sourceMappingURL=Document.js.map